import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from '../../hooks/useTranslation';
import { updateProductRequest, getProductDetailRequest } from '../../store/product/productActions';
import ProductInputs from '../../components/ProductInputs/ProductInputs';
import ProductDetailCard from '../../components/ProductDetailCard/ProductDetailCard';
import { CContainer, CBreadcrumb, CBreadcrumbItem, CCard, CCardHeader, 
  CCardBody, CRow, CCol, CTabs, CTabContent, CTabPane } 
  from '@coreui/react';
import { getProductDropdown } from '../../services/endpoints';

const UpdateProduct = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isLoading = useSelector(state => state.productReducer.isLoading);
  const submitResponse = useSelector(state => state.productReducer.updateProductData);
  const productDetail = useSelector(state => state.productReducer.productDetail);
  const productDetailLoading = useSelector(state => state.productReducer.productDetailLoading);
  const productDetailError = useSelector(state => state.productReducer.productDetailError);
  const initialData = location.state?.product || null;

  const [weaveOptions, setWeaveOptions] = useState([]);
  const [materialOptions, setMaterialOptions] = useState([]);
  const [dropdownLoading, setDropdownLoading] = useState(true);
  const [dropdownError, setDropdownError] = useState(null);
  const [colorOptions, setColorOptions] = useState([]);
  const [yarnOptions, setYarnOptions] = useState([]);
  const [isIMaterial, setIsIMaterial] = useState(false);

  const fetchWeavesByCode = async (weaveCode) => {
    const sessionUserId = localStorage.getItem('sessionUserId');
    const response = await getProductDropdown
    ({ SessionUserId: sessionUserId, WeaveCode: weaveCode || '' });
    return response?.data?.Weaves || [];
  };

  useEffect(() => {
    const fetchDropdown = async () => {
      setDropdownLoading(true);
      setDropdownError(null);
      try {
        const sessionUserId = localStorage.getItem('sessionUserId');
        const response = await getProductDropdown
        ({ SessionUserId: sessionUserId, WeaveCode: initialData?.WeaveCode || '' });
        if (response && response.data && response.data.Weaves) 
        setWeaveOptions(response.data.Weaves);
        if (response && response.data && response.data.Materials) 
        setMaterialOptions(response.data.Materials);
        if (response && response.data && response.data.Colors)
        setColorOptions(response.data.Colors);
        if (response && response.data && response.data.Yarns)
        setYarnOptions(response.data.Yarns);
      } catch (err) {
        setDropdownError('Dropdown verileri alınamadı.');
      } finally {
        setDropdownLoading(false);
      }
    };
    fetchDropdown();
  }, [initialData?.WeaveCode]);

  const handleWeaveSearch = async (searchTerm) => {
    try {
      const weaves = await fetchWeavesByCode(searchTerm);
      setWeaveOptions(weaves);
    } catch (err) {
      setWeaveOptions([]);
    }
  };

  useEffect(() => {
    if (initialData?.PrdProductGuid) {
      const sessionUserId = localStorage.getItem('sessionUserId');
      dispatch(getProductDetailRequest({
        SessionUserId: sessionUserId,
        ProductGuid: initialData.PrdProductGuid
      }));
    }
  }, [initialData, dispatch]);

  // Check if initial material starts with 'i'
  useEffect(() => {
    if (initialData?.PrdMaterialGuid && materialOptions.length > 0) {
      const selectedMaterial = materialOptions.find(m => m.PrdMaterialGuid === 
        initialData.PrdMaterialGuid);
      const isInitialMaterialIMaterial = 
      selectedMaterial?.MaterialName?.toLowerCase().startsWith('i');
      setIsIMaterial(isInitialMaterialIMaterial);
    }
  }, [initialData, materialOptions]);

  const handleSubmit = (data) => {
    dispatch(updateProductRequest({ ...data, navigate }));
  };

  const handleCancel = () => {
    navigate('/products');
  };

  const handleMaterialChange = (materialGuid, isIMaterial) => {
    setIsIMaterial(isIMaterial);
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/products" onClick={e => 
          { e.preventDefault(); handleCancel(); }}>{t('products')}</CBreadcrumbItem>
        <CBreadcrumbItem active>{t('updateProduct')}</CBreadcrumbItem>
      </CBreadcrumb>
      
      <CTabs activeTab="edit">
        
        <CTabContent>
          <CTabPane data-tab="edit" visible>
            <CRow>
              <CCol xs={12}>
                <CCard>
                  <CCardHeader><h4>{t('updateProduct')}</h4></CCardHeader>
                  <CCardBody>
                    <ProductInputs
                      onSubmit={handleSubmit}
                      onCancel={handleCancel}
                      isLoading={isLoading}
                      submitResponse={submitResponse}
                      initialData={initialData}
                      isEdit={true}
                      weaveOptions={weaveOptions}
                      materialOptions={materialOptions}
                      dropdownLoading={dropdownLoading}
                      dropdownError={dropdownError}
                      colorOptions={colorOptions}
                      yarnOptions={yarnOptions}
                      onMaterialChange={handleMaterialChange}
                      onWeaveSearch={handleWeaveSearch}
                    />
                  </CCardBody>
                </CCard>
              </CCol>
            </CRow>
          </CTabPane>
          
          {!isIMaterial && (
            <CTabPane data-tab="details" visible>
              <CRow>
                <CCol xs={12}>
                  <ProductDetailCard
                    productDetail={productDetail}
                    isLoading={productDetailLoading}
                    error={productDetailError}
                  />
                </CCol>
              </CRow>
            </CTabPane>
          )}
        </CTabContent>
      </CTabs>
    </CContainer>
  );
};

export default UpdateProduct; 